(() => {
  document.querySelectorAll('.antar-rw').forEach((root) => {
    if (root.dataset.dialogReady) return;
    root.dataset.dialogReady = 'true';
    const dialog = root.querySelector('.antar-rw__lb');
    if (!dialog) return;
    const closeButton = dialog.querySelector('.antar-rw__lb-close');
    let opener, overflow;
    function close() {
      if (!dialog.classList.contains('is-open')) return;
      dialog.classList.remove('is-open');
      dialog.inert = true;
      document.body.style.overflow = overflow;
      opener?.focus();
    }
    root.querySelectorAll('.antar-rw__card').forEach((card) => {
      card.addEventListener('click', (event) => {
        if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        opener = card;
        overflow = document.body.style.overflow;
        const data = card.dataset;
        dialog.querySelector('.antar-rw__lb-img').src = data.photo;
        dialog.querySelector('.antar-rw__lb-quote').textContent = '“' + data.quote + '”';
        dialog.querySelector('.antar-rw__lb-namev').textContent = data.name;
        dialog.querySelector('.antar-rw__lb-studio').src = data.studio;
        dialog.querySelector('.antar-rw__lb-title').textContent = data.title;
        dialog.querySelector('.antar-rw__lb-shop').href = data.url;
        dialog.classList.add('is-open');
        dialog.inert = false;
        document.body.style.overflow = 'hidden';
        closeButton.focus();
      });
    });
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog || closeButton.contains(event.target)) close();
    });
    dialog.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') { event.preventDefault(); close(); }
      if (event.key !== 'Tab') return;
      const last = dialog.querySelector('.antar-rw__lb-shop');
      if (event.shiftKey && document.activeElement === closeButton) {
        event.preventDefault(); last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault(); closeButton.focus();
      }
    });
  });
})();
